import { render } from "./PoOverview.vue?vue&type=template&id=656d9cf6&scoped=true&lang=true"
import script from "./PoOverview.vue?vue&type=script&lang=js"
export * from "./PoOverview.vue?vue&type=script&lang=js"

import "./PoOverview.vue?vue&type=style&index=0&id=656d9cf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656d9cf6"]])

export default __exports__